module.exports = __webpack_public_path__ + "img/1.20f14a07.png";